import {
  Box,
  Grid,
  TextField,
  Button,
  Modal,
  Typography,
  IconButton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  changeNationalID,
  getCurrentUser,
  sendOtp,
  verifyOtp,
} from "../../services/user.service";
import { useDropzone } from "react-dropzone";
import { IoMdClose } from "react-icons/io";
import { toast } from "react-toastify";
import { uploadImage } from "../../services/upload.service";
import LoadingOverlay from "react-loading-overlay";
import Loader from "../../component/loader/Loader";

function UpdateNational() {
  const [data, setData] = useState();
  const [frontImage, setFrontImage] = useState(null);
  const [backImage, setBackImage] = useState(null);
  const [updatedNationalId, setUpdatedNationalId] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [loader, setLoader] = useState(false);

  const handleDropFront = (acceptedFiles) => {
    setFrontImage(acceptedFiles[0]);
  };

  const handleDropBack = (acceptedFiles) => {
    setBackImage(acceptedFiles[0]);
  };

  const { getRootProps: getRootPropsFront, getInputProps: getInputPropsFront } =
    useDropzone({
      onDrop: handleDropFront,
      accept: "image/*",
    });

  const { getRootProps: getRootPropsBack, getInputProps: getInputPropsBack } =
    useDropzone({
      onDrop: handleDropBack,
      accept: "image/*",
    });

  const UserDataCurrent = () => {
    getCurrentUser().then(({ result }) => {
      setData(result);
    });
  };

  useEffect(() => {
    UserDataCurrent();
  }, []);

  const handleSubmit = () => {
    if (!updatedNationalId || !frontImage || !backImage) {
      alert("Please fill in all the fields and upload required images.");
      return;
    }
    setLoader(true);
    sendOtp({ email: data?.Email }).then((res) => {
      if (res) {
        toast.success(res?.message);
        setOpenModal(true);
        setLoader(false);
      }
    });
  };

  const handleModalClose = () => {
    setOpenModal(false);
  };
  const handleChange = (value, index) => {
    const updatedOtp = [...otp];
    updatedOtp[index] = value;
    setOtp(updatedOtp);

    if (value && index < 5) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  const handleOtpSubmit = (otp) => {
    if (!otp || otp.length !== 6) {
      alert("Please enter a valid 6-digit OTP.");
      return;
    }
    setLoader(true);
    const formData1 = new FormData();
    const formData2 = new FormData();
    formData1.append("file", frontImage);
    formData2.append("file", backImage);
    Promise.all([uploadImage(formData1), uploadImage(formData2)]).then(
      async ([res1, res2]) => {
        const payload = {
          updatedNationalID: updatedNationalId,
          updatedFrontCopy: res1?.result,
          updatedBackCopy: res2?.result,
          phoneNumber: data?.Mobile,
          code: otp,
          email: data.Email,
        };
        await changeNationalID(payload).then((res) => {
          setLoader(false);
          setOpenModal(false);
          setOtp(new Array(6).fill(""));
          toast.success(res?.message);
          UserDataCurrent();
        });
      }
    );
  };

  return (
    <div className="min-h-screen bg-gray-100 flex justify-center items-center">
      {data ? (
        <div className="bg-white shadow-md rounded-lg w-[90%] max-w-4xl p-8">
          <h1 className="text-2xl font-semibold text-center text-gray-800 mb-8">
            Update National ID Card
          </h1>
          <Box component="form" onSubmit={(e) => e.preventDefault()}>
            <Grid container spacing={4}>
              {/* Current National ID Details */}
              <Grid item xs={12} md={6}>
                <h2 className="text-lg font-medium mb-2">
                  Current National ID
                </h2>
                <TextField
                  fullWidth
                  label="Current National ID"
                  variant="outlined"
                  InputProps={{ readOnly: true }}
                  value={data?.NationalID || ""}
                  sx={{ backgroundColor: "#f3f4f6" }}
                />
                <div className="mt-4">
                  <p className="text-sm font-medium">Current Front View</p>
                  <img
                    src={
                      data?.National_proof_front &&
                      `${process.env.REACT_APP_UPI}/Images/${data?.National_proof_front}`
                    }
                    alt="Current Front View"
                    className="w-full h-40 object-cover mt-2 rounded-md border"
                  />
                </div>
                <div className="mt-4">
                  <p className="text-sm font-medium">Current Back View</p>
                  <img
                    src={
                      data?.National_proof_back &&
                      `${process.env.REACT_APP_UPI}/Images/${data?.National_proof_back}`
                    }
                    alt="Current Back View"
                    className="w-full h-40 object-cover mt-2 rounded-md border"
                  />
                </div>
              </Grid>

              {/* Update National ID Section */}
              <Grid item xs={12} md={6}>
                <h2 className="text-lg font-medium mb-2">Update National ID</h2>
                <TextField
                  fullWidth
                  label="New National ID"
                  variant="outlined"
                  value={
                    data?.UpdatedNationalID
                      ? data.UpdatedNationalID
                      : updatedNationalId
                  }
                  onChange={(e) => setUpdatedNationalId(e.target.value)}
                  sx={{ backgroundColor: "#fff" }}
                  className="mb-4"
                  disabled={data?.UpdatedNationalID}
                />
                <div className="mb-4">
                  <p className="text-sm font-medium">Upload Front Side</p>
                  <div
                    {...getRootPropsFront()}
                    className="flex justify-center items-center mt-2 h-40 border-2 border-dashed rounded-md text-gray-500 hover:bg-gray-100"
                  >
                    <input {...getInputPropsFront()} />
                    {frontImage || data?.Updated_National_proof_front ? (
                      <img
                        src={
                          data?.Updated_National_proof_front
                            ? `${process.env.REACT_APP_UPI}/Images/${data?.Updated_National_proof_front}`
                            : URL.createObjectURL(frontImage)
                        }
                        alt="Front Preview"
                        className="w-full h-full object-cover rounded-md"
                      />
                    ) : (
                      <p>Drag & Drop or Click to Upload</p>
                    )}
                  </div>
                </div>
                <div className="mb-4">
                  <p className="text-sm font-medium">Upload Back Side</p>
                  <div
                    {...getRootPropsBack()}
                    className="flex justify-center items-center mt-2 h-40 border-2 border-dashed rounded-md text-gray-500 hover:bg-gray-100"
                  >
                    <input {...getInputPropsBack()} />
                    {backImage || data?.Updated_National_proof_back ? (
                      <img
                        src={
                          data?.Updated_National_proof_back
                            ? `${process.env.REACT_APP_UPI}/Images/${data?.Updated_National_proof_back}`
                            : URL.createObjectURL(backImage)
                        }
                        alt="Back Preview"
                        className="w-full h-full object-cover rounded-md"
                      />
                    ) : (
                      <p>Drag & Drop or Click to Upload</p>
                    )}
                  </div>
                </div>
                {data?.UpdatedNationalID ? (
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    className="mt-4 text-center"
                    sx={{
                      mt: 4,
                      textAlign: "center",
                      backgroundColor: "#f0f8ff",
                      color: "#333",
                      fontWeight: "bold",
                      padding: "10px",
                      borderRadius: "5px",
                      border: "1px solid #b0c4de",
                    }}
                  >
                    National ID has been updated. Please wait for approval from
                    the team.
                  </Typography>
                ) : (
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    className="mt-4"
                    onClick={handleSubmit}
                  >
                    Submit Updates
                  </Button>
                )}
              </Grid>
            </Grid>
          </Box>
        </div>
      ) : (
        <Loader />
      )}

      <Modal open={openModal} onClose={handleModalClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "400px",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: "8px",
            outline: "none",
          }}
        >
          {/* Close Button */}
          <IconButton
            onClick={handleModalClose}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "#333",
            }}
          >
            <IoMdClose />
          </IconButton>

          {/* Modal Title */}
          <Typography
            sx={{
              textAlign: "center",
              fontSize: "16px",
              fontWeight: "600",
              marginBottom: "16px",
            }}
          >
            OTP Verification
          </Typography>

          {/* Instructions */}
          <Typography
            sx={{
              textAlign: "center",
              fontSize: "14px",
              fontWeight: "400",
              marginBottom: "16px",
            }}
          >
            Please check your mail and phone for the OTP. The OTP is valid for{" "}
            <strong>5 minutes</strong>. Enter the OTP below to proceed.
          </Typography>

          {/* OTP Input Boxes */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: "10px",
              marginBottom: "16px",
            }}
          >
            {otp.map((digit, index) => (
              <TextField
                key={index}
                value={digit}
                inputProps={{
                  maxLength: 1,
                  style: {
                    textAlign: "center",
                    fontSize: "20px",
                    fontWeight: "bold",
                  },
                }}
                sx={{
                  width: "40px",
                  height: "40px",
                  bgcolor: "white",
                  borderRadius: "5px",
                }}
                onChange={(e) => handleChange(e.target.value, index)}
                id={`otp-${index}`}
              />
            ))}
          </Box>
          {loader ? (
            <LoadingOverlay />
          ) : (
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                marginTop: "1.5rem",
                bgcolor: "#22C25E",
                fontSize: "16px",
                fontWeight: "bold",
                borderRadius: "5px",
              }}
              onClick={() => handleOtpSubmit(otp.join(""))}
            >
              Submit
            </Button>
          )}
        </Box>
      </Modal>
    </div>
  );
}

export default UpdateNational;
